import AModalHeader from './index.vue';

AModalHeader.install = app => {
  app.component(AModalHeader.name, AModalHeader);
};

export default AModalHeader;
